import { z } from "zod";
const attributesButtonSchema = z.object({
  title: z.string(),
  href: z.string(),
  icon: z.string().optional(),
  isEditable: z.boolean().default(false)
});
export {
  attributesButtonSchema
};
//# sourceMappingURL=attributes.js.map
